import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import JobList from "../components/ActiveJobs"
import PremiumJobList from "../components/PremiumJobs"

const IndexPage = () => {
  return (
  <Layout>
    <SEO title="Home" />
    <p>Curated Product Jobs is a list of hand-picked, great looking Product roles in the UK. No automated scrapers, no mass-importing from other job boards. Only the <strong>good</strong> jobs, in companies you'd actually want to work for. Every role on here has been added by an actual Product Manager.</p>
    <p>See <Link to="/what-makes-a-good-product-job/">what makes a good Product job</Link>.</p>
    {/* <p>Want to see your job on here? <a href="mailto:chris@chriswade.me">Contact us</a> to add a premium listing.</p> */}
    <PremiumJobList />
    <JobList />
  </Layout>
  )}

export default IndexPage
